import {
  SyncPreferenceLabels,
  SyncPreferenceValues,
} from '../enums/StorageProvider';

export const syncPreferencesList = {
  [SyncPreferenceValues.ApprovalPublish]: SyncPreferenceLabels.ManuallyPublish,
  [SyncPreferenceValues.AutoPublish]: SyncPreferenceLabels.AutoPublish,
  [SyncPreferenceValues.NotSync]: SyncPreferenceLabels.DontSync,
};

export const getStorageSyncPreference = (preference: string | undefined) =>
  preference ? syncPreferencesList[preference as SyncPreferenceValues] : '';
